import httpApi from 'hooks/api/httpApi';

import { PlansResponse } from 'models/PlansResponse';
import { Subscription } from 'models/Subscription';
import { SubscriptionStatus } from 'models/SubscriptionStatus';

const subscribe = async (ecomId: number, planId: number) => {
    return httpApi
        .get<string>(`/api/ecom/${ecomId}/subscribe/v2/plan/${planId}`)
        .then((resp) => resp.getData())
        .catch((error) => {
            throw error.response?.data;
        });
};

const subscribeFree = async (ecomId: number, planId: number) => {
    let res = await httpApi.post<string>(`/api/ecom/${ecomId}/subscribe/plan/${planId}`);
    return res.getData();
};

const cancelSubscription = async (ecomId: number) => {
    let res = await httpApi.post<{ response: string }>(`/api/ecom/${ecomId}/cancel-subscription`);
    return res.getData();
};

const cancelSubscriptionFree = async (ecomId: number) => {
    let res = await httpApi.delete<{ response: string }>(`/api/ecom/${ecomId}/cancel-free-subscription`);
    return res.getData();
};

const cancelPendingSubscription = async (ecomId: number) => {
    let res = await httpApi.post<{ response: string }>(`/api/ecom/${ecomId}/cancel-pending-subscription`);
    return res.getData();
};

const getPlans = async (ecomType: string) => {
    let res = await httpApi.get<PlansResponse>(`/api/ecomtype/${ecomType}/plans`);
    return res.getData();
};

const getActiveSubscription = async (ecomId: number) => {
    let res = await httpApi.get<{ active_subscription: Subscription }>(`/api/ecom/${ecomId}/active_subscription`);
    return res.getData().active_subscription;
};

const getActiveSubscriptions = async () => {
    let res = await httpApi.get<Subscription[]>(`/api/v2/active-subscriptions`);
    return res.getData();
};

const getSubscriptionStatus = async (ecomId: number) => {
    let res = await httpApi.get<{ status: string }>(`/api/ecom/${ecomId}/subscription-status`);
    return res.getData();
};

const getSubscriptionStatuses = async () => {
    let res = await httpApi.get<{ subscription_statuses: { [key: number]: SubscriptionStatus } }>(
        `/api/subscription-statuses`
    );
    return res.getData();
};

const confirmCharge = async (chargeId: string, planHandle: string): Promise<void> => {
    //TODO: add confirm charge endpoint in the backend and implement this function to call that endpoint with the chargeId and planHandle as parameters
    return Promise.resolve();
};

export default {
    subscribe,
    cancelSubscription,
    getPlans,
    getActiveSubscription,
    getActiveSubscriptions,
    getSubscriptionStatus,
    getSubscriptionStatuses,
    cancelPendingSubscription,
    subscribeFree,
    cancelSubscriptionFree,
    confirmCharge,
};
